import React from "react";
import Typography from "@material-ui/core/Typography";
import { getAllServiceLogLevels } from "../../services/api/serviceLogLevel.api";
import { Fetcher } from "../../components/Fetcher";
import { ServiceLogLevelDisplayForm } from "../../components/Administration/ServiceLogLevel/ServiceLogLevelDisplayForm";
/**
 * Display ServiceLogLevel form.
 */
export const ServiceLogLevelPage = () => {
	return (
		<div>
			<Typography style={{ marginBottom: 24 }} variant="h4" data-testid="cle-logger-test-page">
				Service Log Levels
			</Typography>
			<Fetcher action={getAllServiceLogLevels()}>
				{(response) => {
					if (response.data.length > 0) {
						return <ServiceLogLevelDisplayForm services={response.data}></ServiceLogLevelDisplayForm>;
					} else return <div>No Services Were Found.</div>;
				}}
			</Fetcher>
		</div>
	);
};
